/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * VerificationMethod with type "Multikey" compatible with
 *           - [Data Integrity ECDSA Cryptosuites v1.0 - 2.1 Verification Methods](https://www.w3.org/TR/vc-di-ecdsa/#verification-methods)
 *           - [Data Integrity EdDSA Cryptosuites v1.0 - 2.1.1 Multikey](https://www.w3.org/TR/vc-di-eddsa/#verification-methods)
 *         .
 */
export interface EcdsaSecp256K1VerificationKey2019 {
    /** List of the contexts of the verification method. */
    context?: string[];
    /** The controller of the verification method. */
    controller: string;
    /** The ID of the verification method. */
    id: string;
    /** The public key of the verification method. */
    publicKeyBase58: string;
    /** The type of the verification method. */
    type: Truvity.EcdsaSecp256K1VerificationKey2019Type;
}
